<template>
  <div class="kpt-detail-content-page" v-if="remote">
    <vue-headful :title="`${remote.name} - Activity`" />
    <div class="kpt-detail-content-actions">
      <activity-log-item :model="activity" v-for="(activity, idx) in activities" :key="idx"></activity-log-item>
    </div>
  </div>
</template>
<script>
import ActivityLogItem from '../../shared/ActivityLogItem.vue';

export default {
  computed: {
    remote() {
      return this.$store.state.remotes.remote;
    },
    activities() {
      return this.$store.state.remotes.remote.activity || [];
    }
  },
  components: {
    ActivityLogItem
  }
}
</script>
